import PropTypes from 'prop-types';

export default {
  // modal contentProps passed through openModal
  description: PropTypes.string,
};
